import { Box, Stack } from "@chakra-ui/react";
import {
  VStack,
  ColorIcon,
  colors,
  customEvent,
  Dropdown,
  FUNERAL_SIGUNGU,
  HStack,
  responsive,
} from "goi_common";

import { useState } from "react";

export default function CareRegionHeadSection({
  sido,
  sidoName,
  sigunguName,
  regionCareCount,
}: {
  sido: string;
  sidoName: string;
  sigunguName?: string;
  regionCareCount: number;
}) {
  const mainRegion = sigunguName ? `${sigunguName}` : `${sidoName}`;

  return (
    <HStack
      justifyContent="space-between"
      css={responsive({
        padding: { base: "0 24px", md: "0" },
      })}
    >
      <Stack position="relative" flex={1}>
        <Box as="h1" className="subtitle_21_b" wordBreak="keep-all" width="85%">
          {mainRegion} 요양원 /{mainRegion} 요양병원
        </Box>
        <Box as="h2" className="subtitle_16_b gray500" wordBreak="keep-all">
          <span className="orange650">{regionCareCount}개</span>의 요양시설이
          있어요
        </Box>
      </Stack>

      <Stack css={{ width: "fit-content", flexBasis: "fit-content" }}>
        <SigunguSelector
          sido={sido}
          sidoName={sidoName}
          sigunguName={sigunguName}
        />
      </Stack>
    </HStack>
  );
}

function SigunguSelector({
  sido,
  sidoName,
  sigunguName,
}: {
  sido: string;
  sidoName: string;
  sigunguName?: string;
}) {
  const sigungus = Array.from(FUNERAL_SIGUNGU.get(Number(sido))!).map(
    (sigungu) => ({
      key: sigungu[1],
      value: String(sigungu[0]),
    })
  );

  const [sigungu] = useState<string | undefined>(sigungus[0].value);

  return (
    <>
      {sigunguName ? (
        <a target="_self" href={`/care/region/${sidoName}/`}>
          <Box
            paddingTop={"4px"}
            paddingBottom="12px"
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            className="body_14_m gray800"
            textAlign="right"
            style={{ cursor: "pointer" }}
            gap="4px"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "care",
                  trigger_and_target: "select_sido-uv_region_sido",
                },
              });
            }}
          >
            <div>
              {sidoName} <br />
              전체보기
            </div>
            <ColorIcon
              name="arrow_right_small"
              color={colors.gray600}
              width="16px"
              height="16px"
            />
          </Box>
        </a>
      ) : (
        <VStack>
          <VStack justifyContent="space-between" alignItems="flex-end">
            <Box className="subtitle_14_sb gray800">지역별로 확인하기</Box>
            <Dropdown
              name="지역"
              forceZIndex={1}
              value={sigungu}
              values={sigungus}
              onChange={(v) => {
                customEvent({
                  newGtm: {
                    path: "care",
                    trigger_and_target: "select_sigungu-select",
                    text: v,
                  },
                });

                const selectSigungu = sigungus.find((s) => s.value === v)?.key;
                window.location.href = `/care/region/${sidoName}-${selectSigungu}/`;
              }}
            />
          </VStack>
        </VStack>
      )}
    </>
  );
}
